module.exports = __webpack_public_path__ + "img/ch13_03_沙滩抱椰子看日落.e7b96f97.jpg";